
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sitesearch/[slug]",
      function () {
        return require("private-next-pages/sitesearch/[slug].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sitesearch/[slug]"])
      });
    }
  